<template>
  <WorkIcon
    v-bind="$props"
  >
    {{ '$wCircle' }}
  </WorkIcon>
</template>

<script>
import WorkIcon from '@/components/global_components/icon/WorkIcon';

/**
 * @component WorkDefaultTabIcon
 * @description Default icon component for tab bars.
 * Wraps `WorkIcon` and passes all props through.
 */
export default {
  name: 'WorkDefaultTabIcon',
  components: { WorkIcon },
  props: { ...WorkIcon.props },
};
</script>
